import store from '@/store'
import { REDIRECT_PATH_ON_AUTH } from 'utils/constants'

export function hasRole (group, role) {
  if (group && role) {
    const groups = store && store.state && store.state.claims && store.state.claims.groups
      ? store.state.claims.groups
      : {}
    return groups[group] ? Boolean(groups[group][role]) : false
  }
}

// https://ptax.bcb.gov.br/ptax_internet/consultarTabelaMoedas.do?method=consultaTabelaMoedas
export function getCurrentLocaleSymbols (locale = null) {
  const selectedLocale = locale || store.state.locale.selected
  const targetLocale = selectedLocale
    ? selectedLocale.toLowerCase().replace('_', '-')
    : null
  const locales = {
    'pt-br': {
      lang: 'pt-br',
      currency: 'BRL',
      date: {
        default: 'DD/MM/YY',
        full: 'DD/MM/YYYY',
        short: 'DD/MM'
      }
    },
    en: {
      lang: 'en',
      currency: 'USD',
      date: {
        default: 'MM/DD/YY',
        full: 'MM/DD/YYYY',
        short: 'MM/DD'
      }
    }
  }

  return locales[targetLocale] || locales['pt-br']
}

export function convertToCurrency (val) {
  const value = !val ? 0 : val
  const { lang, currency } = getCurrentLocaleSymbols()

  return `${value.toLocaleString(lang, {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
      style: 'currency',
      currency
    }
  )}`
}

export function formatNumber (val, placeholder = null) {
  const { lang, currency } = getCurrentLocaleSymbols()
  const defaultConfig = {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
    currency
  }

  if (!val && placeholder) return placeholder
  if (!val) return `${Number(0).toLocaleString(lang, { ...defaultConfig })}`
  return `${val.toLocaleString(lang, { ...defaultConfig })}`
}

export function isSapConcurRoute (params) {
  const regex = /\?id=(.+)?&requestToken=(.+)/
  const isSapConcurURL = regex.test(location.search)

  if (isSapConcurURL) {
    const origin = location.origin
    const [, id, requestToken] = location.search.match(regex)
    location.href = `${origin}/#/sap-concur-integration?id=${id}&requestToken=${requestToken}`
  }

  return isSapConcurURL
}

export function persistRouteOnLocalStorage () {
  localStorage.setItem(REDIRECT_PATH_ON_AUTH, location.hash.replace(/^#/, ''))
}

// TODO:
export function stringToFloat (val) {
  if (!val || val === 'R$ 0,00') return 0

  let str = val.replace(/R\$\s/, '')
  if (str.length < 10) {
    str = str.replace('.', '').replace(',', '.')
  } else {
    const arr = /(.+)\.?(\d{1,2})$/.exec(str)
    str = `${arr[1].replace(/\./g, '').replace(',', '.')}${arr[2]}`
  }

  return Number(str)
}

export function convertToCoin (
  value,
  placeholder = null,
  lang = 'pt-br',
  currency = 'BRL'
) {
  // coin table: https://goo.gl/uFmJj7
  const defaultConfig = {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    style: 'currency',
    currency
  }

  if (!value && placeholder) return placeholder
  if (!value) return `${Number(0).toLocaleString(lang, { ...defaultConfig })}`
  return `${value.toLocaleString(lang, { ...defaultConfig })}`
}
